import { render } from "./OutputTopBar.vue?vue&type=template&id=21f7c3e9&scoped=true"
import script from "./OutputTopBar.vue?vue&type=script&lang=js"
export * from "./OutputTopBar.vue?vue&type=script&lang=js"

import "./OutputTopBar.vue?vue&type=style&index=0&id=21f7c3e9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f7c3e9"]])

export default __exports__